import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UnsetService {
  /**
   * Removes a property from an object using a path string or array
   * @param object The object to remove the property from
   * @param path The path string or array to remove the property from
   * @returns true if the property was removed, false otherwise
   */
  static unset(object: object, path: string | string[]): boolean {
    if (!object || !path) {
      return false;
    }

    // Convert string path to array (e.g., 'a[0].b.c' -> ['a', '0', 'b', 'c'])
    const segments = Array.isArray(path) ? path : path.replace(/\[(\w+)\]/g, '.$1').split('.');

    let current = object;
    const length = segments.length;

    for (let i = 0; i < length - 1; i++) {
      const segment = segments[i];
      if (!(segment in current)) {
        return false;
      }
      current = current[segment as keyof typeof current];
      if (!current || typeof current !== 'object') {
        return false;
      }
    }

    const lastSegment = segments[length - 1];
    if (!(lastSegment in current)) {
      return false;
    }

    return delete current[lastSegment as keyof typeof current];
  }
}
